module.exports = __webpack_public_path__ + "img/symbol_10.8e6fbab1.png";